<template>
    <al-empty-results
      :options="emptyOptions"
      @action="$emit('addTask')"
    ></al-empty-results>
</template>

<script>
export default {
  data() {
    return {
      emptyOptions: {
        title: 'No task selected at the moment',
        showBtn: true,
        btnText: 'Add task',
      },
    };
  },
};
</script>
